module.exports = __webpack_public_path__ + "icon-arrow-right-white.svg?39b21b8ecf106f182458ad0fa0a1eba1";